import React, { useEffect, useRef, useState } from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  CircularProgress,
  Container,
  Typography,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Site from './Site';
import CategoryManager from './Category';
import ProductManager from './Products';
import CrouselsManager from './Crousel';
import OffersManager from './Offers';
import ContactManager from './Contact';
import TabManager from './Tabs';
import api from './api';

function SiteManager({ memberID }) {
  const [siteData, setSiteData] = useState(null);
  const [error, setError] = useState('');
  const [reload, setReload] = useState(0);
  const [processing, setProcessing] = useState(true);
  const [expanded, setExpanded] = useState(false);
const [countryData,setCountryData]=useState('')
  // 🧷 Refs for each section

  // console.log(countryData)
  const refs = {
    Site: useRef(null),
    Crousels: useRef(null),
    Categories: useRef(null),
    Products: useRef(null),
    Offers: useRef(null),
    Contact: useRef(null),
    Tabs: useRef(null),
  };

  useEffect(() => {
    const fetchSiteData = async () => {
      setProcessing(true);
      try {
        const response = await api.get(`site-v2?memberID=${memberID}`);
        setSiteData(response.data);
      } catch (err) {
        console.error(err);
        setError(err.response?.data?.detail || 'Error fetching site');
      } finally {
        setProcessing(false);
      }
    };

    fetchSiteData();

    const defaultComponent = localStorage.getItem('defaultComponent') ||'Site';
    if (defaultComponent && refs[defaultComponent]) {
      setExpanded(defaultComponent);
      setTimeout(() => {
        refs[defaultComponent].current?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    }
  }, [reload]);

  const refetch = () => {
    setReload((prev) => prev + 1);
  };

    useEffect(() => {
    const fetchCountryData = async () => {
      try {
        const response = await api.get(`country`);
        setCountryData(response.data);
      } catch (err) {
        console.error(err);
        setError(err.response?.data?.detail || 'Error fetching site');
      } 
    };

    fetchCountryData();

    
    
  }, [reload]);

const handleAccordionChange = (panel) => (event, isExpanded) => {
  if (isExpanded) {
    setExpanded(panel);
    localStorage.setItem('defaultComponent', panel); 
    setTimeout(() => {
      refs[panel]?.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 100);
  } else {
    setExpanded(false);
    localStorage.removeItem('defaultComponent'); 
  }
};
  return (
    <Container style={{ marginTop: '10vh', textAlign: processing ? 'center' : 'justify' }}>
      {processing ? (
        <CircularProgress style={{ marginTop: '20vh' }} />
      ) : (
        <>
          <Accordion
            expanded={expanded === 'Site'}
            onChange={handleAccordionChange('Site')}
            ref={refs.Site}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="h6">Site Settings</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Site  countryData ={countryData}siteData={siteData} memberID={memberID} refetch={refetch}  />
            </AccordionDetails>
          </Accordion>

          {siteData && (
            <>
              <Accordion
                expanded={expanded === 'Crousels'}
                onChange={handleAccordionChange('Crousels')}
                ref={refs.Crousels}
              >
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography variant="h6">Crousels</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <CrouselsManager siteData={siteData} refetch={refetch}  />
                </AccordionDetails>
              </Accordion>

              <Accordion
                expanded={expanded === 'Categories'}
                onChange={handleAccordionChange('Categories')}
                ref={refs.Categories}
              >
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography variant="h6">Categories</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <CategoryManager siteData={siteData} refetch={refetch}  />
                </AccordionDetails>
              </Accordion>

              {siteData.categories && siteData.categories[0] && (
                <Accordion
                  expanded={expanded === 'Products'}
                  onChange={handleAccordionChange('Products')}
                  ref={refs.Products}
                >
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography variant="h6">Products</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <ProductManager siteData={siteData} refetch={refetch}  />
                  </AccordionDetails>
                </Accordion>
              )}

              <Accordion
                expanded={expanded === 'Offers'}
                onChange={handleAccordionChange('Offers')}
                ref={refs.Offers}
              >
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography variant="h6">Offers</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <OffersManager siteData={siteData} refetch={refetch}  />
                </AccordionDetails>
              </Accordion>

              <Accordion
                expanded={expanded === 'Contact'}
                onChange={handleAccordionChange('Contact')}
                ref={refs.Contact}
              >
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography variant="h6">Contact Details</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <ContactManager siteData={siteData} refetch={refetch}  />
                </AccordionDetails>
              </Accordion>

              <Accordion
                expanded={expanded === 'Tabs'}
                onChange={handleAccordionChange('Tabs')}
                ref={refs.Tabs}
              >
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography variant="h6">Tabs Manager</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <TabManager siteData={siteData} refetch={refetch}  />
                </AccordionDetails>
              </Accordion>
            </>
          )}
        </>
      )}
    </Container>
  );
}

export default SiteManager;
